import React from "react";
import Box from "../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../services/Notify";
import Loading from "../component/Loading/Loading";
import {ControlLabel, FormGroup} from "react-bootstrap";
import GatewayService from "../services/GateServiceService";
import UserService from "../services/UserService";
import CompanySelector from "../component/Company/CompanySelector";
import FormButtons from "../component/Form/FormButtons";

class GatewayForm extends React.Component {

  service = new GatewayService();

  constructor(props) {
    super(props);
    this.state = {};
    this.state.showCompany = UserService.isSuper();
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
          data => this.setState(
              {
                loading: false,
                entity: data
              }),
          error => {
            const state = {loading: false};
            if (error.response.status === 404) {
              state.message = 'Entidade não encontrada!';
            } else {
              state.message = 'Erro inesperado!';
              Notify.error('Falha o buscar entidade!', error)
            }
            this.setState(state);
          }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;
    const entity = {
      id: existingEntity,
      friendlyName: this.friendlyName.value.trim(),
      company: {id: this.companyId},
      version: entityVersion || 0
    };

    this.service.save(entity).then(
        () => {
          this.props.history.goBack();
          Notify.success('Entidade salva');
        },
        (error) => Notify.error('Falha ao salvar entidade:', error));
  }

  render() {
    const {loading, entity = {}, message, showCompany} = this.state;
    if (loading) {
      return <Loading/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
        <Box info title={entity.friendlyName}>
          <form ref={form => (this.form = form)} onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>
            <FormGroup>
              <ControlLabel>Nome</ControlLabel>
              <input type="text" className="form-control" placeholder="Nome"
                     required
                     name="friendlyName"
                     ref={
                       friendlyName => this.friendlyName = friendlyName
                     }
                     defaultValue={entity && entity.friendlyName}/>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Uuid</ControlLabel>
              <input disabled={true} type="text" className="form-control" placeholder="uuid"
                     required
                     name="uuid"
                     ref={
                       uuid => this.uuid = uuid
                     }
                     defaultValue={entity && entity.uuid}/>
            </FormGroup>

            {showCompany ? <CompanySelector defaultValue={entity && entity.company && entity.company.id}
                                            setValue={
                                              companyId => this.companyId = companyId}/>
                : ''}

            <FormButtons history={this.props.history}/>

          </form>
        </Box>);
  }
}

GatewayForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default GatewayForm;



// WEBPACK FOOTER //
// ./src/gateways/GatewayForm.js